import './text-input.scss'
import { ReactComponent as EditIcon } from 'assets/icons/edit.svg'

const TextInput = ({
  value,
  label,
  onChange,
  name,
  type = 'text',
  unit,
  placeholder,
  isLocked,
  onUnlock,
  pattern,
  disabled,
  onEnter,
  lockedLabel = 'mixed',
}) => {
  const inputPlaceholder = isLocked ? lockedLabel : placeholder
  const inputDisabled = isLocked ? true : disabled
  const inputValue = value === null ? '' : value
  function handleKeydown(evt) {
    if (evt.key === 'Enter' && onEnter !== undefined) {
      onEnter()
    }
  }
  return (
    <div className="text-input">
      <label htmlFor={name}>{label}</label>
      <div className="input-container">
        <input
          type={type}
          value={inputValue}
          onChange={onChange}
          name={name}
          id={name}
          placeholder={inputPlaceholder}
          pattern={pattern}
          disabled={inputDisabled}
          onKeyUp={handleKeydown}
        />
        {unit && <div className="unit">{unit}</div>}
        {isLocked && (
          <div className="absolute top-0 right-0 ">
            <button
              className="bg-gray hover:bg-deep b-0 border-0 h-[45px] w-[45px] flex items-center justify-center rounded-r-half"
              onClick={onUnlock}
            >
              <EditIcon height="20" width="20" fill="#ccc" />
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

export default TextInput
